<template lang="html">
  <div class="answerQuestions">
    <div class="answerQuestionsContent">
      <div class="answerCard">
        <p class="answerTxt">提供答疑服务</p>
        <div class="answerUsinghelp" @click="linkOutTo(pagebase + '/h5/agreement/usinghelp.html')">
          <p>使用帮助</p>
          <img src="@/assets/image/icon/icon1.png" alt="">
        </div>
      </div>

      <div class="answerHint">
        <p class="answerCon"> 图文+视频答疑 </p>
        <p class="xian"></p>
        <p class="answerCon"> 48小时必响应 </p>
      </div>

      <div class="teacherGrade" v-if="teacherData.response_rate || teacherData.average_score">
        <div class="responseRate" v-if="teacherData.response_rate">应答率 {{teacherData.response_rate}}%</div>
        <div class="responseRate" v-else> 暂无评分 </div>
        <div v-if="teacherData.average_score">
          <Rating :comment='teacherData.average_score' />
        </div>
        <div v-else> 暂无评分 </div>
      </div>
      <div class="teacherGrade" v-else>
        暂无评分
      </div>

      <div class="priceBtn">
        <p>
          {{teacherData.answer_price}}巢币 咨询
          <WxOpenTag ref="wxopentag" :extinfo="'question/expertHome?id=' + teacherData.uid" />
        </p>
      </div>
    </div>

    <div class="openQuestionCon">
      <ul class="tabTilte">
        <li class="tabMod" @click="cur = 0" :class="{active:cur == 0}">
          公开的答疑
        </li>
        <li class="tabMod" @click="cur = 1" :class="{active:cur == 1}">
          答疑评价
        </li>
      </ul>

      <div class="tabContent">
        <div v-show="cur == 0">
          <div v-if="openQuestionCode >= 0">
            <div class="open" v-for="(a, index) in openQuestionData.data" :key="index" @click="goProblemDetails(a.id)">
              <div class="openTeacherCard">
                <div class="openTeacher">
                  <div class="teacherImg">
                    <img :src="a.avatar" alt="" class="teacherHead">
                    <img src="@/assets/image/icon/tv.png" alt="" class="teacherMark">
                  </div>
                  <div>
                    <p class="teacherName">{{a.username}}</p>
                    <p class="teacherRank">{{a.official_title}}</p>
                  </div>
                </div>

                <div class="lookAnswer">
                  {{a.answer_price}}巢币 看答案
                </div>
              </div>

              <div class="problem">
                <div class="problemImg">
                  <img src="@/assets/image/icon/icon2.png" alt="">
                </div>
                <p>{{a.question_content}}</p>
              </div>
            </div>
          </div>

          <div class="noInfo" v-else>
            <div>
              <img :src="`${pagebase}/static/img/elecom/circle.png`" alt="">
            </div>
            <p>暂无公开的答疑哦~</p>
          </div>
        </div>

        <div v-show="cur == 1">
          <div v-if="commentCode >= 0">
            <div class="answerEvaluate" v-for="(b, index) in commentData.data" :key="index" @click="goProblemDetails(b.question_id)">
              <div class="teacherImg">
                <img :src="b.avatar" alt="" class="evaluateHeader">
                <img src="@/assets/image/icon/tv.png" alt="" class="teacherMark" v-show="b.mp_type == 1">
                <img src="@/assets/image/icon/tv.png" alt="" class="teacherMark" v-show="b.mp_type == 2">
              </div>

              <div class="evaluateCon">
                <div class="evaluateInfo">
                  <p class="evaluateName">{{b.username}}</p>
                  <Rating :comment='b.score' />
                </div>
                <p class="evaluateTxt">{{b.evaluate_content}}</p>
              </div>

              <WxOpenTag ref="wxopentag" :extinfo="'question/detail?id=' + b.question_id" />
            </div>
          </div>

          <div class="noInfo" v-else>
            <div>
              <img :src="`${pagebase}/static/img/elecom/circle.png`" alt="">
            </div>
            <p>暂无答疑评价哦~</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Rating from '@/components/Rating';
  import WxOpenTag from '@/components/WxOpenTag';
  import {
    pagebase
  } from '@/utils/http.js';

  export default {
    props: ['userId'],

    data() {
      return {
        pagebase: pagebase,
        teacherData: {},
        openQuestionCode: '',
        openQuestionData: {},
        commentCode: '',
        commentData: {},
        cur: 0,
      }
    },

    components: {
      Rating,
      WxOpenTag,
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getTeacherData();
        this.getUserOpenQuestionList();
        this.getCommentList();
        document.title = '答疑专家主页';
      },

      // 答疑专家信息
      getTeacherData() {
        this.$http({
          url: '/question/getTeacherData',
          method: 'get',
          params: {
            master_id: this.userId,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.teacherData = res.data;
          }
        })
      },

      getUserOpenQuestionList() {
        this.$http({
          url: '/question/getUserOpenQuestionList',
          method: 'get',
          params: {
            master_id: this.$route.query.uid,
            page: 1,
            limit: 10,
          }
        }).then(res => {
          this.openQuestionCode = res.code;
          if (res.code >= 0) {
            this.openQuestionData = res.data;
          }
        })
      },

      getCommentList() {
        this.$http({
          url: '/question/getCommentList',
          method: 'get',
          params: {
            master_id: this.$route.query.uid,
            page: 1,
            limit: 10,
          }
        }).then(res => {
          this.commentCode = res.code;
          if (res.code >= 0) {
            this.commentData = res.data;
          }
        })
      },

      linkOutTo(url) {
        window.location.href = url
      },

      goProblemDetails(id) {
        sessionStorage.setItem('cur', 10);
        this.$router.push({
          path: '/problemDetails',
          query: {
            qid: id,
          }
        })
      },
    },
  }
</script>

<style lang="css" scoped>
  .answerQuestions {
    background-color: #F7F8F8;
  }

  .answerQuestionsContent {
    position: relative;
    box-sizing: border-box;
    background-color: #FFFFFF;
    padding: 0 1.5rem;
    padding-top: 1rem;
    padding-bottom: 2rem;
    border-radius: 1rem 1rem 0 0;
    z-index: 10;
  }

  .teacherCard {
    position: relative;
    display: flex;
    align-items: center;
  }

  .answerCard {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .answerTxt {
    font-size: 1.5rem;
    color: #333333;
    font-weight: 600;
  }

  .answerUsinghelp {
    display: flex;
    font-size: 1.3rem;
    color: #777777;
    display: flex;
    align-items: center;
  }

  .answerUsinghelp img {
    width: 1.4rem;
    height: 1.4rem;
    margin-left: .2rem;
  }

  .answerHint {
    height: 6.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(to right, #FAF4F2, #F3F7FA);
    margin-top: .95rem;
  }

  .answerCon {
    font-size: 1.4rem;
    color: #333333;
    font-weight: 600;
  }

  .xian {
    width: .05rem;
    height: 2.25rem;
    background-color: #AFBAC5;
    margin: 0 4.2rem;
  }

  .teacherGrade {
    display: flex;
    align-items: center;
    margin-top: .8rem;
    font-size: 1.2rem;
    color: #777777;
  }

  .responseRate {
    font-size: 1.2rem;
    color: #777777;
    margin-right: 1rem;
  }

  .priceBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.7rem;
  }

  .priceBtn p {
    position: relative;
    width: 16.7rem;
    height: 3.7rem;
    background-color: #F7443F;
    border-radius: 3.7rem;
    color: #FFFFFF;
    font-size: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .openQuestionCon {
    margin-top: 1rem;
    background-color: #FFFFFF;
  }

  /* tab */
  .tabTilte {
    box-sizing: border-box;
    padding: 0 1.5rem;
    width: 100%;
    height: 4.4rem;
    display: flex;
    background-color: #FFFFFF;
    border-bottom: .05rem solid #C0C4CC;

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: none;
    text-decoration: none;
  }

  .tabMod {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-right: 2rem;
    font-size: 1.6rem;
    color: #808598;
  }

  .active {
    font-size: 1.6rem;
    color: #1D2023;
    font-weight: 600;
  }

  .active:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    text-align: center;
    width: 3.2rem;
    height: .2rem;
    margin-left: -1.6rem;
    background-color: red;
    border-radius: .6rem;
    z-index: 1;
  }

  .tabContent {
    box-sizing: border-box;
    padding: 0 1.5rem;
  }

  .open {
    position: relative;
    padding: 1.4rem 0;
  }

  .openTeacherCard {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .openTeacher {
    display: flex;
  }

  .teacherImg {
    position: relative;
    height: 3.4rem;
    margin-right: 1.1rem;
  }

  .teacherHead {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 50%;
    object-fit: cover;
  }

  .teacherImg>.teacherMark {
    position: absolute;
    left: 2.2rem;
    bottom: 0;
    width: 1.2rem;
    height: 1.2rem;
  }

  .teacherName {
    font-size: 1.4rem;
    color: #333333;
  }

  .teacherRank {
    font-size: 1.2rem;
    color: #888880;
  }

  .lookAnswer {
    width: 9.4rem;
    height: 2.8rem;
    border: .05rem solid #F7443F;
    color: #F7443F;
    border-radius: 2.8rem;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .problem {
    display: flex;
    align-items: flex-start;
    margin-top: 1rem;
  }

  .problemImg {
    box-sizing: border-box;
    height: 3.4rem;
    width: 4.5rem;
    padding-right: 1.1rem;
    display: flex;
    justify-content: flex-end;
  }

  .problemImg img {
    height: 1.35rem;
  }

  .problem p {
    width: 30rem;
    font-size: 1.3rem;
    color: #555555;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  /* 评价 */
  .answerEvaluate {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1.5rem 0;
  }

  .evaluateHeader {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 50%;
  }

  .evaluateCon {
    display: flex;
    flex-direction: column;
  }

  .evaluateInfo {
    width: 30rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: .6rem;
    margin-bottom: 1.25rem;
  }

  .evaluateName {
    font-size: 1.4rem;
    font-weight: 600;
  }

  .evaluateTxt {
    font-size: 1.3rem;
    color: #555555;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  /* 缺省页 */
  .noInfo {
    height: 25rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }

  .noInfo img {
    width: 19.5rem;
    height: 19.5rem;
  }

  .noInfo p {
    font-size: 1.4rem;
    color: #9CA3A9;
  }
</style>
